import {
  Divider,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Progress,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';

import Modal from 'components/Modal';
import AdjustBalanceModal from 'containers/TimeOff/Modal/AdjustBalanceModal';
import RecordTimeOffModal from 'containers/TimeOff/Modal/RecordTimeOffModal';
import { roles } from 'global/rolesAndPermissions';
import { useUserInfo } from 'store/useUserStore';

import TransactionHistories from './TransactionHistories';

type TBalanceDetailsProps = {
  onClose?: () => void;
  balanceDetails: any;
};

const BalanceDetails: React.FC<TBalanceDetailsProps> = ({ balanceDetails, onClose: onBalanceDetailsDrawerClose }) => {
  const userInfo = useUserInfo();

  return (
    <DrawerContent>
      <DrawerCloseButton top="4" />
      <DrawerHeader display="flex" justifyContent="space-between" pr="60px">
        {balanceDetails?.category_name || ''}

        {userInfo.roleId !== roles.EMPLOYEE ? (
          <Menu size="sm">
            <MenuButton
              as={IconButton}
              size="sm"
              aria-label="vertical-menu"
              icon={<BsThreeDotsVertical size="18px" />}
              variant="ghost"
            />
            <MenuList>
              <Modal
                modalProps={{ size: 'md', isCentered: false }}
                modalTrigger={onOpen => (
                  <MenuItem fontSize="md" onClick={onOpen}>
                    Record time off
                  </MenuItem>
                )}
              >
                {onClose => (
                  <RecordTimeOffModal
                    onClose={() => {
                      onClose();
                      if (onBalanceDetailsDrawerClose) {
                        onBalanceDetailsDrawerClose();
                      }
                    }}
                    data={{
                      user: balanceDetails?.user,
                      category: {
                        id: balanceDetails?.category_id,
                        name: balanceDetails?.category_name,
                        inHours: balanceDetails?.in_hours,
                      },
                    }}
                  />
                )}
              </Modal>
              <Modal
                modalProps={{ size: 'md', isCentered: false }}
                modalTrigger={onOpen => (
                  <MenuItem fontSize="md" onClick={onOpen}>
                    Adjust balance
                  </MenuItem>
                )}
              >
                {onClose => (
                  <AdjustBalanceModal
                    onClose={() => {
                      onClose();
                      if (onBalanceDetailsDrawerClose) {
                        onBalanceDetailsDrawerClose();
                      }
                    }}
                    data={{
                      user: balanceDetails?.user,
                      category: {
                        id: balanceDetails?.category_id,
                        name: balanceDetails?.category_name,
                        inHours: balanceDetails?.in_hours,
                      },
                    }}
                  />
                )}
              </Modal>
            </MenuList>
          </Menu>
        ) : null}
      </DrawerHeader>
      <DrawerBody mt="3">
        <Flex alignItems="center" flex="1 1 auto" gridGap="8px">
          <Text>{balanceDetails.balance}</Text>{' '}
          <Progress flex="1 1 auto" value={balanceDetails.percentage} colorScheme="primary" borderRadius="base" />
          <Text>{balanceDetails.used}</Text>
        </Flex>
        <Divider my="5" borderBottomWidth="2px" borderStyle="dashed" />
        <Flex justifyContent="space-between" p="2">
          <Text textTransform="uppercase" fontSize="12px" flex={{ base: '0 0 150px', md: 'none' }}>
            Carried over from the last year
          </Text>
          <Text>{balanceDetails?.balance_from_previous_year}</Text>
        </Flex>
        <Flex justifyContent="space-between" p="2">
          <Text textTransform="uppercase" fontSize="12px" flex={{ base: '0 0 150px', md: 'none' }}>
            Total Requested
          </Text>
          <Text>{balanceDetails?.sum_of_all_requests}</Text>
        </Flex>
        <Flex justifyContent="space-between" p="2">
          <Text textTransform="uppercase" fontSize="12px" flex={{ base: '0 0 150px', md: 'none' }}>
            To be carried over to the next year
          </Text>
          <Text>{balanceDetails?.balance_to_be_carryover}</Text>
        </Flex>

        <TransactionHistories histories={balanceDetails?.transaction_history || []} />
      </DrawerBody>
    </DrawerContent>
  );
};

export default BalanceDetails;
